/**
 * Plan-based access helpers for SaaS workspace vs Clinch platform routes.
 */

import { isTenantWorkspaceHost } from '@/utils/saasPlatform'

/** Reserved for Clinch platform operators — not workspace Starter/Growth/Scale. */
export const CLINCH_PLATFORM_ONLY_PATHS = [
  '/manage/clients',
  '/manage/credit-monitor',
  '/manage/debit-orders',
  '/manage/payment-proofs',
  '/manage/whatsapp-usage',
  '/manage/settlements',
  '/manage/packages',
  '/manage/billing-rates',
  '/manage/reporting',
  '/manage/wallets',
  '/manage/withdrawals',
  '/manage/xero-accounting',
]

/**
 * Workspace tenant admin self-service (not Clinch ops).
 * Includes Platform theme so workspace Host system_admin can edit BrandTheme
 * via /api/branding/ without Access Denied.
 */
export const WORKSPACE_ADMIN_PATHS = [
  '/manage/subscription',
  '/manage/settlement',
  '/manage/store-wallet',
  '/onboarding',
  '/manage/appearance',
]

export function isClinchPlatformOnlyPath(path) {
  if (!path) return false
  return CLINCH_PLATFORM_ONLY_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
}

export function isWorkspaceAdminPath(path) {
  if (!path) return false
  return WORKSPACE_ADMIN_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
}

export function isWorkspaceOwnerUser(user) {
  if (!user || user.is_superuser) return false
  const code = user.user_type?.code || user.user_type
  if (code === 'system_admin' || code === 'workspace_owner') return true
  return false
}

/** Hide Clinch-only nav on tenant workspace hosts. */
export function sidebarPathAllowed(user, path) {
  if (isClinchPlatformOnlyPath(path)) {
    if (isTenantWorkspaceHost()) return false
    if (isWorkspaceOwnerUser(user)) return false
  }
  return true
}

export function routeBlockedOnTenantHost(path) {
  return isTenantWorkspaceHost() && isClinchPlatformOnlyPath(path)
}

export function workspaceFeatureEnabled(user, featureKey) {
  const features = user?.entitlements?.features
  if (!features || typeof features !== 'object') return true
  return Boolean(features[featureKey])
}
